import { SupportedCountry } from "@/constants/country";
import { LANGUAGE_CONFIG } from "@/lib/i18n/config/languages";
import type { SupportedLanguage } from "@/lib/i18n/config/languages";

/**
 * Maps a locale string to a country code
 * @param locale The locale string (e.g., "en-US", "ja-JP") or null
 * @returns The corresponding country code
 */
export function mapLocaleToCountryCode(
  locale: string | null,
): SupportedCountry {
  // defaultはUSとする
  if (locale === null || !Object.keys(LANGUAGE_CONFIG).includes(locale)) {
    return SupportedCountry.US;
  }

  const localeToCountryMap: Record<SupportedLanguage, SupportedCountry> = {
    "en-US": SupportedCountry.US,
    "ja-JP": SupportedCountry.JP,
    "id-ID": SupportedCountry.ID,
    "vn-VN": SupportedCountry.VN,
    "th-TH": SupportedCountry.TH,
    "zh-CN": SupportedCountry.CN,
  };

  return localeToCountryMap[locale as SupportedLanguage];
}
